import { createDiscreteApi, lightTheme, darkTheme, type ConfigProviderProps } from "naive-ui"
import type { GlobalThemeOverrides } from "naive-ui"

// import { useColorTheme } from "./useTheme"

// const { state } = useColorTheme()
// const configProviderPropsRef = computed<ConfigProviderProps>(() => ({
//     theme: state.value === "light" ? lightTheme : darkTheme,
// }))

export const useThemeOverrides: GlobalThemeOverrides = {
    common: {
        infoColor: "#03c",
        infoColorHover: "#06f",
        infoColorPressed: "#03c",
        infoColorSuppl: "#06f",
        primaryColor: "#F50508",
        primaryColorHover: "#C40406",
        primaryColorPressed: "#F50508",
        primaryColorSuppl: "#FECCCD",
        successColor: "#67c23a",
        successColorHover: "#85ce61",
        errorColor: "#f56c6c",
        errorColorHover: "#f78989",
        fontFamily: `-apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
        scrollbarWidth: "10px",
        scrollbarHeight: "10px",
        scrollbarBorderRadius: "6px",
        scrollbarColor: "#b0c0d0",
        scrollbarColorHover: "#969ba4",
        borderColor: "#dbe0e5",
        dividerColor: "#dbe0e5",
    },
    Button: {
        rippleColor: "#f3f5f9",
        colorHover: "#f3f5f9",
        border: "1px solid #bbb",
        borderFocus: "1px solid #bbb",
        borderHover: "1px solid #505766",
        textColorHover: "#374151",
        textColorPressed: "#374151",
        textColorFocus: "#374151",
        borderColor: "#dbe0e5",
        borderPressed: "#505766",
    },
    DataTable: {
        thPaddingSmall: "4.5px 10px 3px",
        tdPaddingSmall: "14px 10px",
        thColor: "#f3f4f6",
        fontSizeSmall: "13px",
        thFontWeight: "600",
        borderColor: "#dbe0e5",
        thTextColor: "#111",
        tdTextColor: "#111",
    },
    Pagination: {
        itemBorder: "none",
        itemBorderDisabled: "none",
        itemBorderHover: "none",
        itemBorderPressed: "none",
        itemColorDisabled: "transparent",
        itemColorHover: "#f3f4f6",
        itemColorActive: "#9ca3af",
        itemColorActiveHover: "#6b7280",
        itemBorderActive: "none",
        itemTextColor: "#4b5563",
        itemTextColorHover: "#4b5563",
        itemTextColorActive: "#fff",
        itemTextColorDisabled: "#6b7280",
        buttonBorder: "none",
        buttonBorderHover: "none",
        buttonBorderPressed: "none",
        buttonColorHover: "#f3f4f6",
        buttonIconColor: "#4b5563",
        buttonIconColorHover: "#4b5563",
    },
    Input: {
        border: "1px solid #d1d5db",
        borderHover: "1px solid #4b5563",
        borderFocus: "1px solid #1d4ed8",
        boxShadowFocus: "none",
        boxShadowFocusError: "none",
        boxShadowFocusWarning: "none",
    },
    InternalSelection: {
        border: "1px solid #d1d5db",
        borderHover: "1px solid #4b5563",
        borderFocus: "1px solid #1d4ed8",
        borderActive: "1px solid #1d4ed8",
    },
    InternalSelectMenu: {
        optionTextColor: "#5c606b",
        optionTextColorActive: "#5c606b",
        optionColorActivePending: "#f3f4f6",
        optionColorPending: "#f3f4f6",
        optionColorActive: "#dbeafe",
        borderRadius: "0",
        optionHeightMedium: "32px",
        optionFontSizeMedium: "12px",
    },
    Spin: {
        sizeMedium: "60px",
        fontSize: "12px",
    },
}

const { message, notification, dialog, loadingBar } = createDiscreteApi(
    ["message", "dialog", "notification", "loadingBar"],
    {
        configProviderProps: {
            themeOverrides: useThemeOverrides,
        },
    },
)

export const useMessage = () => message

export const useNotification = () => notification

export const useDialog = () => dialog

export const useLoadingBar = () => loadingBar
